import React, {useState} from 'react';
import IntlMessages from "../../../util/IntlMessages";
import {CisUI} from "../../../util/CISUI";
import jsonfile from "./voucher.json";
import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    message,
    Modal,
    Popover,
    Row,
    Select,
    Tooltip
} from "antd";
import moment from "moment/moment";
import Config from "../../../util/config";
import * as XLXS from "xlsx";
import {useHistory} from "react-router-dom";
import axios from "../../../util/Api";

const {Option} = Select;

const ImportVoidedVoucher = (props) => {
    const history = useHistory();
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [templateFile, setTemplateFile] = useState("");

    const [items, setItems] = useState([]);

    // const ItemCellChange = (index, value) => {
    //
    // }
    const showModal = () => {
        // document.getElementById("file").file.value = "";
        setItems([]);
        setIsModalOpen(true);
        // document.getElementById("file").value = "";
    };
    const handleOk = () => {
        // onChangeExcel();
        if(templateFile === ''){
            message.error("Please upload template file.")
            return;
        }

        onChangeExcel(templateFile)
        // setTemplateFile("");
        setIsModalOpen(false);

    };
    const handleCancel = () => {
        // setTemplateFile("");
        setIsModalOpen(false);
    };

    const onChangeExcel = (e) => {
        setItems([]);
        let file = e.target.files[0];
        // let file = docu;
        // setDataObject([]);
        let debitT = 0;
        let creditT = 0;
        let newArray = [];
        if(file !== "") {
            // console.log(file.type);
            if (file.type === 'text/csv' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/x-vnd.oasis.opendocument.spreadsheet' || file.type === 'application/vnd.ms-excel') {
                // console.log(file);
                // document.getElementById("loader").style.display = "block";
                let reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = (e) => {
                    const bufferArray = e.target.result;
                    const wb = XLXS.read(bufferArray, {type: 'buffer'});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data1 = XLXS.utils.sheet_to_json(ws);
                    console.log("data1...", data1);
                    // setData(data1);

                    const subsChars = o => Object.fromEntries(Object.entries(o).map(
                        ([k, v]) => [k.replace(/[ \W]/g, m => m === ' ' ? '_' : '').toLowerCase(), v]
                    ))

                    newArray = data1.map(subsChars)
                    console.log("data1....", newArray)
                    let newObject = [];
                    if (newArray.length <= 202) {
                        newArray?.map((dt, index) => {

                            // console.log("data11....",dt);
                            const str = dt['voucher_no'];
                            const lastChar = str.slice(-1);

                            let debit = dt['receipt'];
                            let debitAmount = debit;
                            // console.log("debit: ", typeof debit);
                            if(typeof debit === 'string') {
                                if (debit.includes('₵')) {
                                    debitAmount = debit.replace('₵', "");
                                }
                            }

                            let credit = dt['payment'];
                            let creditAmount = dt['payment'];
                            // console.log("credit: ", typeof credit);
                            if(typeof credit === 'string') {
                                if (credit.includes('₵')) {
                                    creditAmount = credit.replace('₵', "");
                                }
                            }
                            let voucher_type = 1;
                            let receiptDisabled = 0;
                            let paymentDisabled = 0;
                            if(lastChar === 'R'){
                                voucher_type = 2;
                                paymentDisabled = 1;
                                creditAmount = 0.00;
                            }

                            if(lastChar === 'P'){
                                receiptDisabled = 1;
                                debitAmount = 0.00;
                            }

                            newObject.push({
                                row_id: dt['row_id'],
                                voucher_no: dt['voucher_no'],
                                date: moment(dt['date'], 'YYYY-MM-DD'),
                                // date: dt['date'],
                                voucher_type: voucher_type,
                                receipt_disabled: receiptDisabled,
                                payment_disabled: paymentDisabled,
                                debit: debitAmount,
                                credit: creditAmount
                            })
                        });

                        // console.log("data1.......",newObject);

                        setItems(newObject)

                    } else {
                        message.error('Data Validation check error. 200 rows allowed at a time.');
                    }

                    // if(newArray[0]["beneficiary"] === 'Area') {
                    //
                    // }
                    // else {
                    //     message.error('Invalid Import File. Please import using the template.');
                    // }

                    // document.getElementById("loader").style.display = "none";

                }
            } else {
                message.error('You can only upload XlSX(Only Excel File) formatted file!');
                // document.getElementById("loader").style.display = "none";
            }

        }

    }

    // const handleExcelImport = () => {
    //
    //     if(templateFile === ''){
    //         message.error("Please upload template file.")
    //         return;
    //     }
    //
    //     onChangeExcel(templateFile)
    //
    //
    //     console.log("type", templateFile)
    // }

    const ItemCellChange = (e, id, field_name) => {
        const list = [...items];
        console.log("e",e)
        console.log("e",id)
        if(field_name === 'date'){
            list[id][field_name] = moment(e, 'DD/MM/YYYY')
        }else {
            list[id][field_name] = e;
        }

        setItems(list);
    };

    const handleRowDelete = (id) => {
        // console.log('id', id)

        let newArr = items.filter((item, index) => index !== id);
        setItems(newArr);
    };

    const onFinish = (values) => {
        let data = {
            items: items,
        }
        document.getElementById("loader").style.display = "block";
        axios.post(Config.apiserver + jsonfile.urls.voidedvoucherfix, data)
            .then(res => {
                // console.log(res)
                if (res.data.status === 1) {
                    CisUI().showAlert("Success","success",res.data.msg);
                    document.getElementById("loader").style.display = "none";
                    history.push("../entries/voucherlist");
                } else {
                    CisUI().showAlert("Alert","warning",res.data.msg);
                    document.getElementById("loader").style.display = "none";
                }
            })
            .catch(errors => {
                document.getElementById("loader").style.display = "none";
            });
    }

    return (
        <Card title={<IntlMessages id={"Restore Voided Voucher"}/>}>
            {CisUI().showLoading}
            <div className="row" style={{ marginBottom: "15px" }}>
                <div className="col-md-12">
                    <h2>Instructions for Uploading Voided Voucher File</h2>
                </div>
                <div className="col-md-12">
                    <ul>
                        <li>Upload Format: Only Excel (.xls / .xlsx) files are supported.</li>
                        <li>File Content: The file must include valid voucher records that need to be fixed.</li>
                        <li>File Accuracy: Make sure the data in the Excel file is correct and properly formatted.</li>
                        <li>Header Row: Ensure the first row contains column headers (no extra title rows above it).</li>
                        <li>One File at a Time: Only one file can be uploaded per submission.</li>
                        <li>Validation: The system will automatically validate the uploaded data before processing.</li>
                        <li>Processing: Once uploaded, the system will display the records for review.</li>
                        {/*<li>Action: After review, confirm to fix the selected voided vouchers.</li>*/}
                    </ul>
                </div>
            </div>

            <Form
                form={form}
                {...CisUI().formItemLayout}
                name="input"
                // ref={formRef}
                className="ant-advanced-search-form"
                onFinish={onFinish}
                initialValues={{remember: true}}
            >

                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <h2>Voucher Items</h2>
                            </div>
                            <div className="col-md-6" style={{textAlign: "right"}}>
                                <a className="btn btn-default" style={{background: '#d9e8f4'}}
                                   onClick={showModal}
                                >
                                    Import Excel</a>
                            </div>
                        </div>

                        <table id="itemtable" className="ptable table table-bordered">
                            <thead>
                            <tr>
                                <th>Action</th>
                                <th>Row ID</th>
                                <th>Voucher No</th>
                                <th>Date</th>
                                <th>Voucher Type</th>
                                <th style={{width: "120px", textAlign: "right"}}>Receipt</th>
                                <th style={{width: "120px", textAlign: "right"}}>Payment</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                items.length === 0 ?
                                    <tr>
                                        <td colSpan="7" style={{textAlign: "center", height: "150px"}}>
                                            <span
                                                style={{fontSize: "18px"}}>No data found <br/> Please upload a file.</span>
                                        </td>
                                    </tr>
                                    :

                                    items?.map((item, idx) =>
                                        <tr key={idx}>
                                            <td>
                                                <a
                                                    onClick={() => handleRowDelete(idx)}
                                                    className="btn btn-primary btn-circle">
                                                    <i className="fa fa-trash"></i>
                                                </a>
                                            </td>
                                            <td>
                                                <Input value={item.row_id}
                                                       onChange={(e) => ItemCellChange(e, idx, "row_id")}
                                                       disabled={true} style={{color: "#000"}}/>
                                            </td>
                                            <td>
                                                <Input value={item.voucher_no}
                                                       onChange={(e) => ItemCellChange(e, idx, "voucher_no")}
                                                       disabled={true} style={{color: "#000"}}/>
                                            </td>
                                            <td>
                                                <DatePicker value={item.date}
                                                    format={CisUI().dateFormat}
                                                    disabled={true}
                                                    onChange={(date, dateString) => ItemCellChange(dateString, idx, "date")}
                                                    className="gx-w-100" style={{color: "#000 !important"}}/>
                                            </td>
                                            <td>

                                                <Select
                                                    showSearch
                                                    placeholder="Select an company"
                                                    optionFilterProp="children"
                                                    onChange={(e) => ItemCellChange(e, idx, 'voucher_type')}
                                                    className="gx-w-100"
                                                    value={item.voucher_type}
                                                    disabled={true}
                                                    style={{color: "#000 !important"}}
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    <Option value={1}>Payment</Option>
                                                    <Option value={2}>Receipt</Option>
                                                </Select>

                                            </td>
                                            <td>
                                                <InputNumber value={item.debit}
                                                             onChange={(e) => ItemCellChange(e, idx, 'debit')}
                                                             className="gx-w-100" style={{textAlign: "right"}}
                                                             disabled={item.receipt_disabled}/>

                                            </td>
                                            <td>
                                                <InputNumber value={item.credit}
                                                             onChange={(e) => ItemCellChange(e, idx, 'credit')}
                                                             className="gx-w-100" style={{textAlign: "right"}}
                                                             disabled={item.payment_disabled}/>
                                            </td>
                                        </tr>
                                    )
                            }

                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12" style={{textAlign: 'center', marginTop: '30px'}}>
                        <Button id="submitbutton" type="primary" htmlType="submit">
                            Submit
                        </Button>
                        <Button type="info" onClick={() => history.goBack()} htmlType="back">Cancel</Button>
                    </div>
                </div>
            </Form>

            <Modal title="Excel Import" open={isModalOpen} onOk={handleOk} okText={"Done"} onCancel={handleCancel}>
                <p>
                    <div id="msg"></div>
                    <div className="row">

                        <div className="col-md-12">

                            {/*<Upload{...uplod}>*/}
                            {/*    <Button icon={<UploadOutlined />}>Click to Upload</Button>*/}
                            {/*</Upload>*/}
                            <div style={{fontWeight: 'bold', paddingBottom: '5px'}}>Choose / Load Excel File</div>
                            {/*<input type="file" id="file" onChange={onChangeExcel} />*/}
                            <input type="file" id="file" onChange={(e) => setTemplateFile(e)} />
                        </div>

                        {/*<div className="col-md-12 mt-3">*/}
                        {/*    <Button type="primary" htmlType="button" onClick={handleExcelImport}>*/}
                        {/*        Submit*/}
                        {/*    </Button>*/}
                        {/*</div>*/}
                    </div>
                </p>
            </Modal>
        </Card>
);
}

export default ImportVoidedVoucher;